import {i18n} from './i18n';

export default i18n;

export {i18n} from './i18n';
export {FALLBACK_LANGUAGE} from './fallbackLanguage';
export {MESSAGE_FORMAT_OPTIONS} from './messageFormatOptions';
/**
 * The reviewed locale bundles, for specs that need to read published copy
 * rather than a key.
 *
 * The repo-wide Jest setup replaces i18next with a stripped copy whose `t`
 * returns the key, so no ordinary spec ever renders what a user reads — which
 * is how a flat `"{count} triggers"` shipped as "1 triggers" through 678 green
 * tests. A spec that wants the real sentence builds its own i18next out of
 * `jest.requireActual` and needs the bundle as data; these three are the
 * locales anybody here can check.
 */
export {default as enGBTranslations} from './locales/en-GB.json';
export {default as csCZTranslations} from './locales/cs-CZ.json';
export {default as skSKTranslations} from './locales/sk-SK.json';
